import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Is this safe for children?',
  answer: "The handbook includes a dedicated section on children's health with age-appropriate dosages and clear safety notes. As with any health decision involving children, we recommend using good judgment and consulting a healthcare provider for serious conditions."
}, {
  question: 'How do I get access?',
  answer: "Immediately after payment you'll receive an email with your download link. Everything is delivered digitally — no waiting, no shipping."
}, {
  question: "Isn't this just stuff I can find for free on Google?",
  answer: "Fair question — and we get it. The internet is full of natural remedy tips. The problem isn't finding information. The problem is that it's scattered, contradictory, and you never know what's actually safe, what dosage to use, or what to do when you can't find a specific ingredient.\n\nThe Home Healing Handbook isn't a collection of Google searches. It's 300 remedies organized by symptom — with exact dosages, preparation times, ingredient substitutes, and safety notes for children and adults.\n\nThe difference is the same as between searching 'chest pain causes' on Google at 2am versus having a trusted doctor in the room with you.\n\nOne gives you anxiety. The other gives you answers."
}, {
  question: "I'm not experienced with natural remedies. Will this work for me?",
  answer: "That's exactly who this was designed for. No prior knowledge needed. Every remedy includes step-by-step instructions, exact amounts, and what to use if you can't find a specific ingredient."
}, {
  question: "What if it doesn't work for me?",
  answer: "Then we don't deserve your money. 14-day full refund, no questions asked."
}, {
  question: 'Is there a monthly fee?',
  answer: 'Absolutely not. This is a one-time payment of $27. You own it forever.'
}, {
  question: 'Why is the price so low?',
  answer: "We're in our launch phase and we need real testimonials from real women who use this with their families. So we made the entry price impossible to say no to. Once this launch window closes, the price goes to $97."
}, {
  question: 'What if I already know some natural remedies?',
  answer: "Then you'll love having everything in one organized system — especially Bonus #5, the advanced masterclass, which covers tinctures, salves, and building a real home apothecary."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 md:py-14 bg-cream" data-id="element-76">
      <div className="max-w-3xl mx-auto px-4" data-id="element-77">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-dark mb-5 md:mb-8" data-id="element-78">
          FREQUENTLY ASKED QUESTIONS
        </h2>

        <div className="space-y-2 md:space-y-3" data-id="element-79">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-primary/10 overflow-hidden" data-id="element-80">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 md:p-5 text-left hover:bg-primary/5 transition-colors" data-id="element-81">
                <span className="font-bold text-dark pr-4" data-id="element-82">{faq.question}</span>
                <ChevronDownIcon className={`w-5 h-5 text-primary flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-83" />
              </button>

              {openIndex === index && <div className="px-4 pb-4 md:px-5 md:pb-5 space-y-3" data-id="element-84">
                  {faq.answer.split('\n\n').map((paragraph, pIdx) => <p key={pIdx} className="text-muted leading-relaxed" data-id="element-85">
                      {paragraph}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}